<template>
  <v-dialog v-model="visible" persistent max-width="440">
    <v-card>
      <v-card-title class="headline">Choose a card payment provider</v-card-title>
      <v-card-text>
        <v-btn
          v-for="provider in providers"
          :key="provider"
          block
          color="primary"
          class="mb-2"
          @click="choose(provider)"
        >
          {{ providerLabel(provider) }}
        </v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'payment-provider-choice',
  data: () => ({ visible: false, providers: [], pending: null }),
  mounted() {
    EventBus.$on('payment-provider:choose', this.open)
  },
  beforeDestroy() {
    EventBus.$off('payment-provider:choose', this.open)
    this.cancel()
  },
  methods: {
    open({ enabledProviders, resolve, reject }) {
      if (this.pending) {
        reject(new Error('Payment provider selection is already in progress'))
        return
      }
      this.providers = enabledProviders.filter(provider => ['CORVUS', 'REVOLUT', 'WSPAY'].includes(provider))
      if (this.providers.length !== enabledProviders.length) {
        reject(new Error('Unsupported payment provider'))
        return
      }
      this.pending = { resolve, reject }
      this.visible = true
    },
    providerLabel(provider) {
      return { CORVUS: 'Corvus', REVOLUT: 'Revolut Pay', WSPAY: 'WSPay' }[provider] || provider
    },
    choose(provider) {
      if (!this.pending || !this.providers.includes(provider)) return
      const { resolve } = this.pending
      this.pending = null
      this.visible = false
      resolve(provider)
    },
    cancel() {
      if (!this.pending) return
      const { reject } = this.pending
      this.pending = null
      this.visible = false
      reject(new Error('Payment provider selection was cancelled'))
    },
  },
}
</script>
